// Module
var code = "<div class=\"fg-field-properties\"> <div novalidate ng-form=\"fieldPropertiesForm\"> <div ng-include=\"renderInfo.propertiesTemplateUrl\"></div> </div> </div> ";
// Exports
export default code;